module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAMFBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzPdLkT/zE3/zE3/zE3/zE3/zE3/zE3/zE3ForIZAAAAEHRSTlMAYL//ACDP7///v2AAzyDvDH7t8gAAAHpJREFUSMdjYiACMI0qoqoiIWO8QNHFhcklTBG/MUKKDEyMsoQsuyTAxHiAkKI/AkxnCbv7LJMAYUWMxCkaTQVUVBRKBBgNp1FFQ1mRIBFgNJyoqYh6hb0IYUWOTIwJhNSwCTD9+0JIkf0DJob7hGrOd8TUwaOpgKqKANEYJ0HguWYxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1e9-1f1ea.png
// module id = 590
// module chunks = 0